import { expVal } from '@atlassian/jira-feature-experiments';

const EmpanadaAssigneeAgentDelegateFixRelayprovider = {
	get(): boolean {
		return expVal('empanada_assignee_agent_delegate_fix', 'isEnabled', false);
	},
};

export default EmpanadaAssigneeAgentDelegateFixRelayprovider;
